module.exports = __webpack_public_path__ + "static/media/11_r_kran_81.35_26.2.7a40a6f2.png";